import React from "react";
import { Section, FadeUp, SectionHeading } from "./primitives";

export const Epiphany = () => (
  <Section className="bg-zinc-50">
    <div className="max-w-[720px] mx-auto text-center">
      <FadeUp>
        <SectionHeading>More Practice Clearly Isn't The Answer</SectionHeading>
      </FadeUp>
      <FadeUp delay={0.05}>
        <div className="mt-10 space-y-6 text-lg md:text-xl text-zinc-600 leading-relaxed">
          <p>After years of coaching guitarists, I started noticing the same pattern.</p>
          <p>Some of the players coming to me had been playing for 20, 30, or even 40 years.</p>
          <p>They knew their pentatonic boxes, theory, and exercises inside out.</p>
          <p>
            But when they picked up the guitar to solo, their technique would let them down, and they'd fall
            straight back into the same old repetitive playing.
          </p>
          <p>
            Meanwhile, players with a fraction of their experience were constantly improving their technique,
            improvising with more freedom, and even joining local bands and playing great solos live.
          </p>
          <p className="font-bold text-zinc-900">So the issue wasn't talent.</p>
          <p className="font-bold text-zinc-900">And it wasn't that they simply needed to practise more.</p>
          <p className="font-bold text-zinc-900">The real problem was how they were practising.</p>
          <p>
            If you want real progress on the guitar, you need to stop practising like everyone else and start
            making the changes that actually lead to cleaner technique, better improvisation, and faster, more
            fluid solos.
          </p>
          <p>Not by practising 10 hours a day.</p>
          <p>
            But by following a clear system that shows you what to work on, how to fix your playing, and how to
            turn technique into music.
          </p>
        </div>
      </FadeUp>
    </div>
  </Section>
);
